import React from "react";
import { Box, BoxProps } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface IProps extends BoxProps {
	src: string;
	title?: string;
	center?: boolean;
	width?: string;
	height?: string;
	iframeScale?: number;
	iframeTranslateY?: string;
}

export const YouTubeEmbed = ({
	src,
	title = "",
	center = false,
	iframeScale = 1,
	iframeTranslateY = "0%",
	...rest
}: IProps): JSX.Element => {
	const { t } = useTranslation();
	const playerTitle = title || t("youTubeTitle");

	return (
		<Box
			mx={center ? "auto" : undefined}
			borderRadius="lg"
			overflow="hidden"
			boxShadow="lg"
			position="relative"
			paddingBottom="56.25%"
			height="0"
			{...rest}
		>
			<iframe
				style={{
					position: "absolute",
					top: 0,
					left: 0,
					width: "100%",
					height: "100%",
					border: 0,
					transform: `scale(${iframeScale}) translateY(${iframeTranslateY})`,
					transformOrigin: "center center",
				}}
				src={src}
				title={playerTitle}
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				referrerPolicy="strict-origin-when-cross-origin"
				allowFullScreen
			/>
		</Box>
	);
};
